import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import PublicAccess from './components/PublicAccess';
import { AuthProvider, useAuth } from './context/AuthContext';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  console.log('PrivateRoute: Verificando autenticação:', { user: !!user, loading });
  
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '18px',
        color: '#667eea'
      }}>
        Carregando...
      </div>
    );
  }
  
  if (!user) {
    console.log('PrivateRoute: Usuário não autenticado, redirecionando para /adm-login');
    return <Navigate to="/adm-login" replace />;
  }
  
  console.log('PrivateRoute: Usuário autenticado, renderizando children');
  return children;
};

function App() {
  // Log para debug
  console.log('App.js: Rota atual:', window.location.pathname);
  
  return (
    <AuthProvider>
      <Router basename="/sysconect">
        <Routes>
          <Route path="/" element={<Navigate to="/adm-login" replace />} />
          <Route path="/adm-login" element={<Login />} />
          <Route path="/login" element={<Navigate to="/adm-login" replace />} />
          <Route path="/acesso-publico" element={<PublicAccess />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;

